//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('textileModelCategory7s', {
//        templateUrl: 'views/components/views/textileModelCategory7s/textileModelCategory7s.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'textileModelCategory7sService', function (stateService, textileModelCategory7sService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
            
//            vm.model = {
//                itemsListCategories7: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadTextileModelCategory7s() {
//                vm.model.itemsListCategories7 = await textileModelCategory7sService.listTextileModelCategory7s();
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'textilemodelcategory7':
//                        go({ textilemodelcategory7_keyno: '0' });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadTextileModelCategory7s();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
